import { t } from 'i18next'

export const USER_INFO_TITLE = t('user.info.title')

export const USER_INFO_IS_MAIL_RECEIVE = (value: boolean) =>
  value ? t('common.receive') : t('common.doNotReceive')
